import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputText from '../../commons/form/InputText'
import CampaignGroupModalPage from '../../../containers/masters/CampaignGroup/CampaignGroupModalPage'
import InputSelect from '../../commons/form/InputSelect'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class CampaignGroupMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        searchCode: null,
        searchClassId: null
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchCampaignGroupList()
    this.props.actions.fetchRoleCombo()
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchCampaignGroupList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchCampaignGroupList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleNameChange (searchCode) {
    if (this.state.filter.searchName !== searchCode) {
      this.setState({ filter: { ...this.state.filter, searchCode } })
    }
  }

  handleClassChange (searchClassId) {
    if (this.state.filter.searchClass !== searchClassId) {
      this.setState({ filter: { ...this.state.filter, searchClassId } })
    }
  }

  searchCampaign () {
    this.props.actions.fetchCampaignGroupList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  resetFilters () {
    this.setState({
      filter: {
        searchCode: null,
        searchClassId: null
      }
    }, () => { this.searchCampaign() })
  }

  render () {
    const {
      t, campaignGroupList, pagesCount, campaignGroupCount, filter,
      combos: { campaignClass },
      filter: { page },
      actions: { openCampaignGroupModal, fetchCampaignGroupList, recoverCampaignGroup, deleteCampaignGroup, openEditDocumentalConditionModalSuccess }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'campaignGroupMasterPage' })
    const tKey = 'MASTERS.CAMPAIGN_GROUP_MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const recoverTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}RECOVER`)}</Tooltip>)
    const documentTooltip = (<Tooltip id="documentTooltip">{t(`${tKey}DOCUMENTAL_CONDITIONS`)}</Tooltip>)
    const hasFilters = (this.state.filter.searchClassId || this.state.filter.searchCode)
    return (
      <div id="campaingGroupMaster" className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              className="_Btn new"
              onClick={() => openCampaignGroupModal()}>
              <i className='iDocIcon-add-plus'></i> {t(`${tKey}ADD`)}
            </Button>
          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.code"
                controlLabel={t(`${tKey}CODE`)}
                placeholder={t(`${tKey}CODE`)}
                onInputChange={(value) => this.handleNameChange(value)}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.campaignClassId"
                controlLabel={t(`${tKey}CLASSTYPE`)}
                placeholder={t(`${tKey}CLASSTYPE`)}
                valueKey="id"
                labelKey="value"
                options={campaignClass}
                onInputChange={(value) => this.handleClassChange(value)}
              />
              <div className="search-form-actions flexInLine al-R">
                <Button
                  className={'_Btn accept'}
                  onClick={() => this.searchCampaign()}
                  onKeyDown={(e) => handleKeyDown(e)}>
                  <i className="ico-search" />
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button
                  className={'_Btn accept stk ' + (hasFilters ? ' ' : 'disabled')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}
                >
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              { campaignGroupList.length !== 0 &&
                <Table className="editable-table" hover responsive>
                  <thead>
                    <tr>
                      <th onClick={() => { this.changeOrder('code') }}>
                        {t(`${tKey}CODE`)}
                        <i className={this.getSortIcon('code')} />
                      </th>
                      <th onClick={() => { this.changeOrder('name') }}>
                        {t(`${tKey}NAME`)}
                        <i className={this.getSortIcon('name')} />
                      </th>
                      <th onClick={() => { this.changeOrder('description') }}>
                        {t(`${tKey}DETAILS`)}
                        <i className={this.getSortIcon('description')} />
                      </th>
                      <th onClick={() => { this.changeOrder('classCode') }}>
                        {t(`${tKey}CLASSTYPE`)}
                        <i className={this.getSortIcon('classCode')} />
                      </th>
                      <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {campaignGroupList && campaignGroupList.map((campaignGroup, idx) => {
                      return (
                        <tr key={idx} className={campaignGroup.isDeleted ? 'is-deleted' : ''}>
                          <td>{campaignGroup.groupCode}</td>
                          <td>{campaignGroup.campaignGroupLanguage && campaignGroup.campaignGroupLanguage.length > 0 ? campaignGroup.campaignGroupLanguage.find(lang => (lang.languageId ? lang.languageId : '') === this.props.languageSelected).name : ''} </td>
                          <td>{campaignGroup.campaignGroupLanguage && campaignGroup.campaignGroupLanguage.length > 0 ? campaignGroup.campaignGroupLanguage.find(lang => (lang.languageId ? lang.languageId : '') === this.props.languageSelected).description : ''} </td>
                          <td>{campaignGroup.campaignClassCode}</td>
                          <td className='actions'>
                            {!campaignGroup.isDeleted ? (
                              <div>
                                {!campaignGroup.isCampaign && (
                                  <OverlayTrigger placement="left" overlay={documentTooltip}>
                                    <a className='_Btn accept stk o-icn ' onClick={() => openEditDocumentalConditionModalSuccess(campaignGroup, this.props.languageSelected)}>
                                      <i className="iDocIcon-description-file-data" />
                                    </a>
                                  </OverlayTrigger>
                                )}
                                <OverlayTrigger placement="left" overlay={editTooltip}>
                                  <a className='_Btn accept stk o-icn ' onClick={() => openCampaignGroupModal(campaignGroup)}>
                                    <i className="iDocIcon-edit" />
                                  </a>
                                </OverlayTrigger>
                                <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                  <a className='_Btn cancel stk o-icn ' onClick={() => deleteCampaignGroup(campaignGroup.campaignGroupId)}>
                                    <i className="iDocIcon-delete-forever" />
                                  </a>
                                </OverlayTrigger>
                              </div>
                            ) : (
                              <div>
                                <OverlayTrigger placement="left" overlay={recoverTooltip}>
                                  <a className='_Btn accent stk o-icn ' onClick={() => recoverCampaignGroup(campaignGroup.campaignGroupId)}>
                                    <i className='iDocIcon-undo-back' />
                                  </a>
                                </OverlayTrigger>
                              </div>
                            )}
                          </td>
                        </tr>)
                    })}
                  </tbody>
                </Table>
              }
              {(campaignGroupList === null || campaignGroupList === undefined || campaignGroupList.length === 0) &&
                <p className="no_results" >{t(`${tKey}RESULTS_NOT_FOUND`)}</p>
              }
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_sales"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={campaignGroupCount}
                    onSelectAction={(value) => fetchCampaignGroupList({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
        <CampaignGroupModalPage/>
      </div>
    )
  }
}

export default reduxForm({
  form: 'listCampaignGroup'
})(CampaignGroupMaster)
